/* eslint-disable */
import Swiper from "swiper/dist/js/swiper.js";
import ScrollReveal from "scrollreveal";
import Plyr from "plyr";

export default {
  init() {
    function mainJS() {
      // Link target blank
      $("a").each(function () {
        var a = new RegExp("/" + window.location.host + "/");
        if (!a.test(this.href)) {
          $(this).attr("target", "_blank");
        }
      });

      // Cover
      $(".cover").each(function () {
        var img_ = $(this).find(">img");
        if (!img_.length) {
          img_ = $(this).find("> picture > img");
        }
        if (img_.length) {
          var bg_ = "url(" + img_.attr("src") + ")";
          $(this).css("background-image", bg_);
        }
      });

      // Toggle navigation
      $(".toggle__nav").on("click", function () {
        $("body").toggleClass("show_nav");
        $("body").removeClass("show_search");
      });

      // Toggle search
      $("#search__toggle").on("click", function () {
        $("body").toggleClass("show_search");
        $("body").removeClass("show_nav");
      });

      $(window).scroll(function () {
        $("body").removeClass("show_search");
      });

      // Scroll reveal
      var slideUp = {
        origin: "bottom",
        distance: "32px",
        duration: 900,
        scale: 1,
      };
      ScrollReveal().reveal(".appear", slideUp);

      // Swipers
      new Swiper(".swiper-homepage", {
        // loop: true,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
        },
      });

      // Hide pagination if only one slide
      const swiperHomepage = document.querySelector(".swiper-homepage");
      const mainTitlePagination = document.querySelector(
        ".main__title .swiper-pagination"
      );

      if (swiperHomepage && mainTitlePagination) {
        const hasDisabledButton = swiperHomepage.querySelector(
          ".swiper-button-disabled"
        );

        if (hasDisabledButton) {
          mainTitlePagination.classList.add("hidden");
        }
      }

      new Swiper(".js-gallery", {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 0,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination-fraction",
          type: "fraction",
        },
      });

      new Swiper(".swiper-project", {
        loop: true,
        autoplay: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination-fraction",
          type: "fraction",
        },
      });

      // Video player
      if ($(".video-container").length) {
        const player = new Plyr(".video-container", {
          hideControls: false,
          captions: {
            active: true,
          },
        });
        player.toggleControls(false);

        player.on("play", () => {
          player.toggleControls(true);
        });
      }

      // Municipis
      $(".municipis__select").on("click", function () {
        $(this).toggleClass("active");
      });

      $(".municipis__select-ul li").on("click", function () {
        var text = $(this).text();
        var slug = $(this).attr("data-filter");
        $(".municipis__select-title").text(text);
        $(".municipis__select-ul li").removeClass("active");
        $(this).addClass("active");
        if (slug == "all") {
          $(".actuacio__item").addClass("active");
        } else {
          $(".actuacio__item").removeClass("active");
          $(".actuacio__item." + slug).addClass("active");
        }
      });

      // Ajax projects pagination
      $(".tax-cat-projecte .nav__pagination a").on("click", function (e) {
        e.preventDefault();
        var link = $(this).attr("href");
        $.ajax({
          url: link,
          type: "GET",
          success: function (data) {
            $("#ajax__container").html($(data).find("#ajax__container").html());
            mainJS();
            $("html, body").animate(
              {
                scrollTop: $(".projects__grid").offset().top,
              },
              400
            );
          },
        });
      });
    }

    mainJS();

    // Ajax projects filter
    $(".filter__category").on("click", function (e) {
      e.preventDefault();
      var link = $(this).attr("href");
      $(".filter__category").removeClass("active");
      $(this).addClass("active");
      $.ajax({
        url: link,
        type: "GET",
        success: function (data) {
          $("#ajax__container").html($(data).find("#ajax__container").html());
          mainJS();
          $("html, body").animate(
            {
              scrollTop: $(".projects__grid").offset().top,
            },
            400
          );
        },
      });
    });

    // Google maps
    // var google = '';
    var styles = [
      {
        featureType: "all",
        elementType: "geometry.fill",
        stylers: [
          {
            weight: "2.00",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "geometry.stroke",
        stylers: [
          {
            color: "#9c9c9c",
          },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.text",
        stylers: [
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "administrative.land_parcel",
        elementType: "geometry.fill",
        stylers: [
          {
            visibility: "on",
          },
          {
            color: "#372305",
          },
          {
            saturation: "-25",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [
          {
            color: "#f2f2f2",
          },
        ],
      },
      {
        featureType: "landscape",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [
          {
            saturation: -100,
          },
          {
            lightness: 45,
          },
        ],
      },
      {
        featureType: "road",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#eeeeee",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#7b7b7b",
          },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [
          {
            visibility: "simplified",
          },
        ],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [
          {
            visibility: "off",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [
          {
            color: "#46bcec",
          },
          {
            visibility: "on",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry.fill",
        stylers: [
          {
            color: "#c8d7d4",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [
          {
            color: "#070707",
          },
        ],
      },
      {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [
          {
            color: "#ffffff",
          },
        ],
      },
    ];

    function new_map($el) {
      var $markers = $el.find(".marker");
      var args = {
        zoom: 12,
        center: new window.google.maps.LatLng(0, 0),
        mapTypeId: window.google.maps.MapTypeId.ROADMAP,
        styles: styles,
      };
      var map = new window.google.maps.Map($el[0], args);
      map.markers = [];
      $markers.each(function () {
        add_marker($(this), map, $(".acf-map").attr("data-marker"));
      });
      center_map(map);
      return map;
    }

    function add_marker($marker, map, icon_marker) {
      var latlng = new window.google.maps.LatLng(
        $marker.attr("data-lat"),
        $marker.attr("data-lng")
      );
      var marker = new window.google.maps.Marker({
        position: latlng,
        map: map,
        icon: icon_marker,
      });
      map.markers.push(marker);
      if ($marker.html()) {
        var infowindow = new window.google.maps.InfoWindow({
          content: $marker.html(),
        });
        window.google.maps.event.addListener(marker, "click", function () {
          infowindow.open(map, marker);
        });
      }
    }

    function center_map(map) {
      var bounds = new window.google.maps.LatLngBounds();
      $.each(map.markers, function (i, marker) {
        var latlng = new window.google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        );
        bounds.extend(latlng);
      });
      if (map.markers.length == 1) {
        map.setCenter(bounds.getCenter());
        map.setZoom(14);
      } else {
        map.fitBounds(bounds);
      }
    }

    $(".acf-map").each(function () {
      new_map($(this));
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js